<template>
   <div style="height:150px">
   	<!--指定车辆选择-->
		<form role="form" class="form-inline">
			<div class="col-sm-12">
				<div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="1">导入正式车辆</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="6">导入测试车辆</radio>
					</label>
                </div>
				<div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="2">设备更换</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="3">设备(整机)更换</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="4">SIM更换</radio>
					</label>
                </div>
                <div class="form-group pt5px mr30px">
                    <label>
                    	<radio v-model="type" true-value="5">设备导入模板</radio>
					</label>
                </div>
			</div>
		</form>
		<dropzone  id="myVueDropzone1" v-if="type==1" :url="type1path" v-on:vdropzone-success="showSuccess" :headers="header" maxFileSizeInMB="6">
		 </dropzone>
		 <dropzone  id="myVueDropzone2" v-if="type==2" :url="type2path" v-on:vdropzone-success="showSuccess" :headers="header" maxFileSizeInMB="6">
		 </dropzone>
		 <dropzone  id="myVueDropzone3" v-if="type==3" :url="type3path" v-on:vdropzone-success="showSuccess" :headers="header" maxFileSizeInMB="6">
		 </dropzone>
		 <dropzone  id="myVueDropzone4" v-if="type==4" :url="type4path" v-on:vdropzone-success="showSuccess" :headers="header" maxFileSizeInMB="6">
		 </dropzone>
		 <dropzone  id="myVueDropzone5" v-if="type==5" :url="type5path" v-on:vdropzone-success="showSuccess" :headers="header" maxFileSizeInMB="6">
		 </dropzone>
		 <dropzone  id="myVueDropzone6" v-if="type==6" :url="type6path" v-on:vdropzone-success="showSuccess" :headers="header" maxFileSizeInMB="6">
		 </dropzone>
   </div>
</template>
<script>
import Dropzone from 'vue2-dropzone'
import Radio from 'components/common/Radio' 
	
  export default {
    name: 'FileUpload',
    components: {
		Dropzone,
		Radio
	},
    data() {
      return {
      	 header:{
      	 	'access-token':this.$store.state.user.accesstoken
      	 },
      	 type:'',
      	 type1path:process.env.API_ROOT + '/migration/import/vehicles',
      	 type2path:process.env.API_ROOT + '/migration/import/change/device',
      	 type3path:process.env.API_ROOT + '/migration/import/change/wholedevice',
      	 type4path:process.env.API_ROOT + '/migration/import/change/sim',
      	 type5path:process.env.API_ROOT + '/migration/import/devices',
      	 type6path:process.env.API_ROOT + '/migration/import/vehicles-test'
      };
    },
    methods:{
    	showSuccess:function (file,response) {
    		if (response.message==''){
    			alert("上传成功");
    		}else{
    			alert(response.message);
    		}
    		this.$emit('cancel');
      	}
    }
  };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// FileUpload.vue?3761132e